$(function (e) {
    var typingTimer;                //timer identifier
    var doneTypingInterval = 1000;  //time in ms
    var search_string = null;

    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });

    $('body').on('keyup', '.location-input', function(event) {
        $('#store_locationError').addClass("d-none");
        clearTimeout(typingTimer);
        typingTimer = setTimeout(function() {
            ajaxStoreSearch();
        }, doneTypingInterval);
    });

    function ajaxStoreSearch () {
        if (!$('#store_locationError').hasClass('d-none')) {
            $('#store_locationError').addClass('d-none');
        }
        search_string = $('input[name=store_location]').val();
        if (search_string.length > 2) {
            $.post('/location-get-stores-by-search', {
                store_location: $('input[name=store_location]').val(),
                _token: $('#store_location input[name=_token]').val()
            }).done(function(data) {
                $('.result-list-wrap .row a').remove();
                $.each(JSON.parse(data.data), function(key, value){
                    var address_google = value.store_address.split(' ').join('+');
                    var new_element = `<a href="http://maps.google.com/maps?q=`+address_google+`&ll=`+value.latitude+`,`+value.longitude+`" target="_blank" class="text-default col-md-6 col-12 outline-0 border-0 bg-transparent text-decoration-none mb-4">`;
                    new_element += `<h4 class="mb-1 text-uppercase">`+value.store_name+`</h4>`;
                    new_element += `<p class="mb-2">`+value.store_address+`</p>`;
                    if( value.phone ){
                        new_element += `<p class="mb-2">`+Lang.get('js-return-text.location_label_contact_number')+` `+value.phone+`</p>`;    
                    }
                    if( (value.pickup_start && value.pickup_end) || (value.delivery_start && value.delivery_end) ){
                        new_element += `<p class="mb-2">`+value.opening_hover_text+`</p>`;
                    }
                    if( value.pickup_start && value.pickup_end ){
                        new_element += `<p class="mb-0">`+value.allow_pickup+`: `+value.pickup_start+` - `+value.pickup_end+`</p>`;    
                    }
                    if( value.delivery_start && value.delivery_end ){
                        new_element += `<p class="mb-0">`+value.allow_delivery+`: `+value.delivery_start+` - `+value.delivery_end+`</p>`;    
                    }
                    if( value.allow_delivery || value.allow_delivery ){
                        new_element += `<p class="my-2">`+value.service_hut_text+`</p>`;
                    }
                    if( value.allow_delivery ){
                        new_element += `<p class="mb-1 ms-2"><i class="fas fa-taxi text-theme-red me-1"></i> `+value.allow_delivery+`</p>`;    
                    }
                    if( value.allow_pickup ){
                        new_element += `<p class="mb-1 ms-2"><i class="pizzahut-icons phc-pizzabox me-1"></i> `+value.allow_pickup+`</p>`;    
                    }
                    new_element += `</a>`;
                    $('.result-list-wrap .row').append(new_element);
                });
            }).fail(function(jqXHR, textStatus, errorThrown) {
                $.each(jqXHR.responseJSON,function(tKey,objError){
                    $('#store_location.location-input').val('');
                    $('.result-list-wrap .row a').remove();
                    $('#store_locationError').removeClass('d-none');
                });
            });
        } 
    }

    $('body').on('click', '.button-use-current-location', function(e) {
        if (!$('#store_locationError').hasClass('d-none')) {
            $('#store_locationError').addClass('d-none');
        }
        if (!navigator.geolocation) {
            $("#store_locationError").removeClass("d-none");
            console.log(Lang.get('js-return-text.error_homepage_geolocation_not_support'));
        } else {
            navigator.geolocation.getCurrentPosition(showPosition, showError);
        }
    });

    /* Render Result Store Location List For Find nearest Hut */
    function showPosition(position) {
        // add ajax function here to query for stores available
        $.post('/location-get-stores-by-coordinate', {
            user_longitude: position.coords.longitude,
            user_latitude: position.coords.latitude,
            _token: $('input[name=_token]').val()
        }).done(function(data) {
            $('.result-list-wrap .row a').remove();
            $.each(JSON.parse(data.data), function(key, value){
                var address_google = value.store_address.split(' ').join('+');
                var new_element = `<a href="http://maps.google.com/maps?q=`+address_google+`&ll=`+value.latitude+`,`+value.longitude+`" target="_blank" class="text-default col-md-6 col-12 outline-0 border-0 bg-transparent text-decoration-none mb-4">`;
                new_element += `<h4 class="mb-1 text-uppercase">`+value.store_name+`</h4>`;
                new_element += `<p class="mb-2">`+value.store_address+`</p>`;
                if( value.phone ){
                    new_element += `<p class="mb-2">`+Lang.get('js-return-text.location_label_contact_number')+` `+value.phone+`</p>`;    
                }
                if( (value.pickup_start && value.pickup_end) || (value.delivery_start && value.delivery_end) ){
                    new_element += `<p class="mb-2">`+value.opening_hover_text+`</p>`;
                }
                if( value.pickup_start && value.pickup_end ){
                    new_element += `<p class="mb-0">`+value.allow_pickup+`: `+value.pickup_start+` - `+value.pickup_end+`</p>`;    
                }
                if( value.delivery_start && value.delivery_end ){
                    new_element += `<p class="mb-0">`+value.allow_delivery+`: `+value.delivery_start+` - `+value.delivery_end+`</p>`;    
                }
                if( value.allow_delivery || value.allow_delivery ){
                    new_element += `<p class="my-2">`+value.service_hut_text+`</p>`;
                }
                if( value.allow_delivery ){
                    new_element += `<p class="mb-1 ms-2"><i class="fas fa-taxi text-theme-red me-1"></i> `+value.allow_delivery+`</p>`;    
                }
                if( value.allow_pickup ){
                    new_element += `<p class="mb-1 ms-2"><i class="pizzahut-icons phc-pizzabox me-1"></i> `+value.allow_pickup+`</p>`;    
                }
                new_element += `</a>`;
                $('.result-list-wrap .row').append(new_element);
            });
        }).fail(function(jqXHR, textStatus, errorThrown) {
            $.each(jqXHR.responseJSON,function(tKey,objError){
                $('#store_location.location-input').val('');
                $('.result-list-wrap .row a').remove();
                $('#store_locationError').removeClass('d-none');
            });
        });
    }

    /* Show Error Message For Find nearest Hut */
    function showError(error) {
        $('#store_locationError').removeClass("d-none");
        switch(error.code) {
            case error.PERMISSION_DENIED:
                $('#store_locationError').html(Lang.get('js-return-text.error_homepage_user_denied'));
            break;
            case error.POSITION_UNAVAILABLE:
                $('#store_locationError').html(Lang.get('js-return-text.error_homepage_location_unavailable'));
            break;
            case error.TIMEOUT:
                $('#store_locationError').html(Lang.get('js-return-text.error_homepage_location_timeout'));
            break;
            case error.UNKNOWN_ERROR:
                $('#store_locationError').html(Lang.get('js-return-text.error_homepage_unknown'));
            break;
        }
    }

});